function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/fakeselectionobserver
 */
import Observer from './observer';
import ViewSelection from '../selection';
import { keyCodes } from '@ckeditor/ckeditor5-utils/src/keyboard';
import { debounce } from 'lodash-es';
/**
 * Fake selection observer class. If view selection is fake it is placed in dummy DOM container. This observer listens
 * on {@link module:engine/view/document~Document#event:keydown keydown} events and handles moving fake view selection to the correct place
 * if arrow keys are pressed.
 * Fires {@link module:engine/view/document~Document#event:selectionChange selectionChange event} simulating natural behaviour of
 * {@link module:engine/view/observer/selectionobserver~SelectionObserver SelectionObserver}.
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var FakeSelectionObserver = /*#__PURE__*/function (_Observer) {
  _inherits(FakeSelectionObserver, _Observer);

  var _super = _createSuper(FakeSelectionObserver);

  /**
   * Creates new FakeSelectionObserver instance.
   *
   * @param {module:engine/view/view~View} view
   */
  function FakeSelectionObserver(view) {
    var _this;

    _classCallCheck(this, FakeSelectionObserver);

    _this = _super.call(this, view);
    /**
     * Fires debounced event `selectionChangeDone`. It uses `lodash#debounce` method to delay function call.
     *
     * @private
     * @param {Object} data Selection change data.
     * @method #_fireSelectionChangeDoneDebounced
     */

    _this._fireSelectionChangeDoneDebounced = debounce(function (data) {
      return _this.document.fire('selectionChangeDone', data);
    }, 200);
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FakeSelectionObserver, [{
    key: "observe",
    value: function observe() {
      var _this2 = this;

      var document = this.document;
      document.on('arrowKey', function (eventInfo, data) {
        var selection = document.selection;

        if (selection.isFake && _this2.isEnabled) {
          // Prevents default key down handling - no selection change will occur.
          data.preventDefault();
        }
      }, {
        context: '$capture'
      });
      document.on('arrowKey', function (eventInfo, data) {
        var selection = document.selection;

        if (selection.isFake && _this2.isEnabled) {
          _this2._handleSelectionMove(data.keyCode);
        }
      }, {
        priority: 'lowest'
      });
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(FakeSelectionObserver.prototype), "destroy", this).call(this);

      this._fireSelectionChangeDoneDebounced.cancel();
    }
    /**
     * Handles collapsing view selection according to given key code. If left or up key is provided - new selection will be
     * collapsed to left. If right or down key is pressed - new selection will be collapsed to right.
     *
     * This method fires {@link module:engine/view/document~Document#event:selectionChange} and
     * {@link module:engine/view/document~Document#event:selectionChangeDone} events imitating behaviour of
     * {@link module:engine/view/observer/selectionobserver~SelectionObserver}.
     *
     * @private
     * @param {Number} keyCode
     * @fires module:engine/view/document~Document#event:selectionChange
     * @fires module:engine/view/document~Document#event:selectionChangeDone
     */

  }, {
    key: "_handleSelectionMove",
    value: function _handleSelectionMove(keyCode) {
      var selection = this.document.selection;
      var newSelection = new ViewSelection(selection.getRanges(), {
        backward: selection.isBackward,
        fake: false
      }); // Left or up arrow pressed - move selection to start.

      if (keyCode == keyCodes.arrowleft || keyCode == keyCodes.arrowup) {
        newSelection.setTo(newSelection.getFirstPosition());
      } // Right or down arrow pressed - move selection to end.


      if (keyCode == keyCodes.arrowright || keyCode == keyCodes.arrowdown) {
        newSelection.setTo(newSelection.getLastPosition());
      }

      var data = {
        oldSelection: selection,
        newSelection: newSelection,
        domSelection: null
      }; // Fire dummy selection change event.

      this.document.fire('selectionChange', data); // Call` #_fireSelectionChangeDoneDebounced` every time when `selectionChange` event is fired.
      // This function is debounced what means that `selectionChangeDone` event will be fired only when
      // defined int the function time will elapse since the last time the function was called.
      // So `selectionChangeDone` will be fired when selection will stop changing.

      this._fireSelectionChangeDoneDebounced(data);
    }
  }]);

  return FakeSelectionObserver;
}(Observer);

export { FakeSelectionObserver as default };